import { Component, ElementRef, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '../../services/apis.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Base} from '../base/base';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import Swal from "sweetalert2";
import {NotificationsComponent} from '../notifications/notifications.component';
@Component({
  selector: 'app-edit-document-license',
  templateUrl: './edit-document-license.component.html',
  styleUrls: ['./edit-document-license.component.css']
})
export class EditDocumentLicenseComponent extends Base {
  loading: boolean = false;
  @ViewChild('inputFileEnrollmentFront') inputFileEnrollmentFront: ElementRef;
  @ViewChild('inputFileEnrollmentBack') inputFileEnrollmentBack: ElementRef;
  imageLicenseFront = '';
  imageLicenseBack = '';
  public url_base = this.URL_BASE;
  @Input() public data;
  @Input() public action;

  constructor(injector: Injector,
              private form: FormBuilder,
              private router: Router,
              private NgxSpinner: NgxSpinnerService,
              private apis: ApisService) {
      super(injector);
  }

  ngOnInit() {
    console.log('llego data (this.data, this.action) :: ', this.data, this.action);
  }


  handleInputChange(image, name) {
    let file = image.target.files[0];
    let context = this;
    var reader: any = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      switch (name) {
        case 'driving_license_front':
          context.imageLicenseFront = reader.result.split(',')[1];
          break;
        case 'driving_license_back':
          context.imageLicenseBack = reader.result.split(',')[1];
          break;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  saveImagen(name) {
    if (this.data && this.data.user.id) {
      let image = '';
      let imageOld = '';
      switch (name) {
        case 'driving_license_front':
          image = this.imageLicenseFront;
          imageOld = this.data.documents[0].driving_license_front;
          break;
        case 'driving_license_back':
          image = this.imageLicenseBack;
          imageOld = this.data.documents[0].driving_license_back;
          break;
      }
      let data = {
        user_id: this.data.user.id,
        name: name,
        image: image,
        imageOld: imageOld
      };

      this.apis.UpdateRequestChangeInfoDocuments(data).then(result => {
        if (result['status'] == 'success') {
          this.data[name] = result['data'][name];
        }
      });
    }
  }

  resetInputFile(event, name) {
    console.log('reset ', event);
    switch (name) {
      case 'driving_license_front':
        this.inputFileEnrollmentFront.nativeElement.value = '';
        break;
      case 'driving_license_back':
        this.inputFileEnrollmentBack.nativeElement.value = '';
        break;
    }
  }
}
